import { useQuery } from "@apollo/client/react";
import { useDispatch } from "react-redux";

import { findBookMatchScoreForUser } from "queries/recommendations/getBookMatchScoreForUser";
import { useUserBook } from "store/books/booksSelector";
import { useUserBookMatchScore } from "store/currentUser/currentUserSelector";
import { setMatchScore } from "store/currentUser/currentUserSlice";
import { slugIdConstants } from "types/UserBookStatusType";

import useCurrentUserId from "./user/useCurrentUserId";

export default function useBookMatchScore({
  bookId,
  isVisible,
}: {
  bookId: number;
  isVisible: boolean;
}) {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const userBook = useUserBook(bookId);

  // Get the actual score from Redux
  const score = useUserBookMatchScore(bookId);

  // Skip fetching match percentage if:
  //   Not logged in
  //   Already marked as read
  //   Already loaded
  useQuery(findBookMatchScoreForUser, {
    skip:
      userBook?.statusId === slugIdConstants.read ||
      score === null ||
      score > 0 ||
      !isVisible,
    variables: {
      bookId,
      userId,
    },
    onCompleted: data => {
      if (data.recommendations.length === 0) {
        dispatch(setMatchScore({ bookId, score: null }));
      } else {
        dispatch(
          setMatchScore({ bookId, score: data.recommendations[0].score }),
        );
      }
    },
  });

  return score;
}
